if (!customElements.get('f-scroll-nav')) {
  customElements.define(
    'f-scroll-nav',
    class FScrollNav extends HTMLElement {
      connectedCallback() {
        this.track = document.querySelector(this.dataset.track);
        if (!this.track) return;

        this.prev = this.querySelector('[data-scroll-prev]');
        this.next = this.querySelector('[data-scroll-next]');
        this.dotsWrap = this.querySelector('[data-scroll-dots]');
        this.dotCount = 0;

        this.onScroll = this.raf(() => this.update());
        this.onResize = this.raf(() => this.build());

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this.track);

        this.prev?.addEventListener('click', () => this.scrollByStep(1));
        this.next?.addEventListener('click', () => this.scrollByStep(-1));

        this.build();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.observer?.disconnect();
      }

      raf(fn) {
        let frame = null;
        return () => {
          if (frame) return;
          frame = requestAnimationFrame(() => {
            frame = null;
            fn();
          });
        };
      }

      // Only children that are actually laid out — the section renders the
      // "image" block twice and hides one per breakpoint.
      get items() {
        return Array.from(this.track.children).filter((el) => el.offsetWidth > 0);
      }

      get step() {
        const first = this.items[0];
        if (!first) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      get rtl() {
        return getComputedStyle(this.track).direction === 'rtl';
      }

      build() {
        if (this.dotsWrap) {
          const count = this.items.length;
          if (count !== this.dotCount) {
            this.dotCount = count;
            this.dotsWrap.replaceChildren();
            for (let i = 0; i < count; i += 1) {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'f-scroll-nav__dot';
              dot.setAttribute('aria-label', `Go to slide ${i + 1} of ${count}`);
              dot.setAttribute('aria-controls', this.track.id);
              dot.addEventListener('click', () => this.scrollToIndex(i));
              this.dotsWrap.appendChild(dot);
            }
          }
        }
        this.update();
      }

      update() {
        const pos = Math.abs(this.track.scrollLeft);
        const max = this.track.scrollWidth - this.track.clientWidth;

        if (this.prev) this.prev.disabled = pos <= 1;
        if (this.next) this.next.disabled = pos >= max - 1;

        if (this.dotsWrap && this.dotCount) {
          const index = Math.min(this.dotCount - 1, Math.round(pos / this.step));
          Array.from(this.dotsWrap.children).forEach((dot, i) => {
            dot.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        }
      }

      scrollByStep(dir) {
        const sign = this.rtl ? 1 : -1;
        this.track.scrollBy({ left: this.step * dir * sign, behavior: 'smooth' });
      }

      scrollToIndex(i) {
        const sign = this.rtl ? -1 : 1;
        this.track.scrollTo({ left: this.step * i * sign, behavior: 'smooth' });
      }
    }
  );
}